import "./App.css";
import Nav from "./components/nav/Nav";
import Introduction from "./components/introduction/Introduction";
import ProjectsHero from "./components/projectsHero/ProjectsHero";
import Techs from "./components/techs/Techs";
import Contacts from "./components/contacts/Contacts";
import Footer from "./components/footer/Footer";
import Projects from "./components/projects/Projects";
import { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import TokenServices from "./services/TokenServices";
import GoogleAnalytics from "./components/googleAnalytics/GoogleAnalytics";
function App() {
	useEffect(() => {
		async function checkToken() {
			const hasToken = await TokenServices.hasTokenCookies();
			if (!hasToken) {
				await TokenServices.login();
			}
		}
		checkToken();
	}, []);
	return (
		<Router>
			<GoogleAnalytics />
			<div className="App">
				<Nav />
				<div className="container-fluid container-lg" id="hero">
					<Routes>
						<Route
							path="/"
							element={
								<>
									<Introduction />
									<ProjectsHero />
									<Techs />
									<Contacts />
								</>
							}
						/>
						<Route
							path="/projetos"
							element={
								<>
									<Projects />
								</>
							}
						/>
						<Route path="*" element={<h1>404</h1>} />
					</Routes>
				</div>
				<Footer />
			</div>
		</Router>
	);
}

export default App;
